import { Box, Grid } from "@mui/material";
import InfoBar from "components/common/InfoBar";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import Chip from "../../common/Chip";
import Typography from "../../common/Typography";
import "./MetricsContent.scss";

interface Props {
  metricDetails?: any;
  metricsBar?: boolean;
  sx?: object;
  isDashboard?: boolean;
  showValue2?: boolean;
}

function MetricsContent(props: Readonly<Props>) {
  const { metricDetails, metricsBar = true, isDashboard = false, showValue2, sx } = props;
  const { metricsName, metricName2, chipDetails, timeFrameName, dateAsOf, metricValue2, metricScoreDetails } =
    metricDetails;
  const stringData = getUIFormatDate(dateAsOf) === "Invalid date";
  const metri2Class =
    metricValue2?.backGroundColor === tokens.Background.Feedback.Overdue
      ? "metric-value-overdue"
      : "metric-value-success";
  if (metricsBar)
    return (
      <Grid className="metrics-bar" sx={{ ...sx }}>
        <Grid item xs={12} display="flex" justifyContent="space-between" flexWrap="wrap">
          <Grid item md={8}>
            <Typography variant="body1" showBold color={tokens.Text.General.PrimaryHeadline} textAlign={"left"}>
              {metricsName}
            </Typography>
            <Box>
              {" "}
              <>
                {" "}
                {dateAsOf && (
                  <Typography variant="label" component={"div"} color={"inherit"} textAlign={"left"}>
                    {stringData ? dateAsOf : `As of ${getUIFormatDate(dateAsOf)}`}
                  </Typography>
                )}
                <Typography variant="label" component={"div"} color={"inherit"} textAlign={"left"}>
                  {timeFrameName}
                </Typography>
              </>
            </Box>
          </Grid>

          {metricScoreDetails && (
            <Grid item md={4} className="metric-score metric-value">
              <Typography variant="h5" color={metricScoreDetails?.color} component={"span"} sx={{ marginRight: "4px" }}>
                {metricScoreDetails?.label}
              </Typography>
              <Typography color={metricScoreDetails?.color} component={"span"}>
                {metricScoreDetails?.icon}
              </Typography>
            </Grid>
          )}
        </Grid>
        {showValue2 && (
          <Grid item xs={12} display="flex" justifyContent="space-between" flexWrap="wrap">
            <Grid item md={6} xs={8}>
              <Typography variant="body2" showBold color={tokens.Text.General.Secondary} textAlign={"left"}>
                {metricName2}
              </Typography>
            </Grid>
            {chipDetails && (
              <Grid item md={6} className="metric-value">
                <Chip
                  backgroundColor={chipDetails?.backGroundColor}
                  color={chipDetails?.color}
                  borderColor={
                    chipDetails?.backGroundColor === "transparent"
                      ? tokens.Text.General.PrimaryHeadline
                      : chipDetails?.color
                  }
                  label={chipDetails?.label}
                  icon={chipDetails?.icon}
                />
              </Grid>
            )}
            {!metricValue2?.showBg ? (
              <Grid item md={4} className="metric-value">
                <Typography
                  textAlign={"right"}
                  variant="body2"
                  color={metricValue2?.color}
                  component={"span"}
                  sx={{ marginRight: "4px" }}
                >
                  {metricValue2?.label}
                </Typography>
                <Typography textAlign={"right"} color={metricScoreDetails?.color} component={"span"}>
                  {metricValue2?.icon}
                </Typography>
              </Grid>
            ) : (
              <Grid item md={5} className="metric-value">
                <Chip
                  backgroundColor={metricValue2?.backGroundColor}
                  color={metricValue2?.color}
                  borderColor={metricValue2?.backGroundColor === "transparent" ? null : metricValue2?.color}
                  label={metricValue2?.label}
                  icon={metricValue2?.icon}
                />
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    );
  else {
    let chipData = metricValue2?.showBg ? metricValue2 : chipDetails;
    let showVal2Class = showValue2 ? "" : "show-no-value";
    return (
      <Grid className={`metrics-info-bar ${showVal2Class}`}>
        <InfoBar
          sx={{
            flexDirection: "row",
            justifyContent: isDashboard ? "centre" : "space-between",
            ...sx
          }}
          label={metricsName}
          //TODO:testing
          // showMetricScore={!isEmpty(chipDetails) || !isEmpty(metricValue2)}
          showMetricScore={true}
          coloredScore={
            metricScoreDetails && (
              <Typography
                variant="body2"
                showBold
                color={metricScoreDetails?.color}
                sx={{ marginLeft: { xs: "auto", gap: "2px" } }}
                className="vertical-center"
              >
                {metricScoreDetails?.label}
                {metricScoreDetails?.icon}
              </Typography>
            )
          }
          progressChip={
            chipData
              ? {
                  backgroundColor: chipData?.backGroundColor,
                  color: chipData?.color,
                  borderColor: chipData?.color,
                  label: chipData?.label,
                  icon: chipData?.icon
                }
              : {
                  backgroundColor: "transparent",
                  color: metricValue2?.color,
                  label: metricValue2?.label,
                  icon: metricValue2?.icon
                }
          }
        ></InfoBar>
      </Grid>
    );
  }
}

export default MetricsContent;
